"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "mb-3"
};
const _hoisted_2 = { class: "text-left font-bold uppercase border-b border-slate-400" };
const _hoisted_3 = { class: "text-center" };
const _hoisted_4 = { class: "text-center" };
const _hoisted_5 = { class: "text-right" };
const _hoisted_6 = { class: "text-right" };
const _hoisted_7 = {
    key: 1,
    class: "mb-3"
};
const _hoisted_8 = { class: "text-left font-bold uppercase border-b border-slate-400" };
const _hoisted_9 = { class: "font-bold" };
const _hoisted_10 = { class: "font-bold" };
const _hoisted_11 = { class: "font-bold" };
const _hoisted_12 = { class: "font-bold" };
const _hoisted_13 = { class: "text-center" };
const _hoisted_14 = { class: "text-right" };
const _hoisted_15 = { class: "text-right" };
const vue_3 = require("vue");
const i18n_1 = require("../../common/i18n");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'OpenOrderItems',
    props: {
        openOrder: {
            type: Object,
        },
    },
    setup(__props) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const props = __props;
        //COMPUTED
        const openOrderItemOpenedListFields = (0, vue_3.ref)([
            {
                key: "productId",
                label: (_a = (0, i18n_1.trans)("item_id_opened_list", "Item ID", "open_order_items")) !== null && _a !== void 0 ? _a : "Item ID",
                value: "productId",
            },
            {
                key: "productName",
                label: (_b = (0, i18n_1.trans)("name_opened_list", "Name", "open_order_items")) !== null && _b !== void 0 ? _b : "Name",
                value: "productName",
            },
            {
                key: "quantity",
                label: (_c = (0, i18n_1.trans)("quantity_opened_list", "Quantity", "open_order_items")) !== null && _c !== void 0 ? _c : "Quantity",
                value: "quantity",
            },
            {
                key: "reservedQuantity",
                label: (_d = (0, i18n_1.trans)("reserved_quantity_opened_list", "Reserved Quantity", "open_order_items")) !== null && _d !== void 0 ? _d : "Reserved Quantity",
                value: "reservedQuantity",
            },
            {
                key: "formattedPriceUnitNet",
                label: (_e = (0, i18n_1.trans)("net_unit_price_opened_list", "Net Unit Price", "open_order_items")) !== null && _e !== void 0 ? _e : "Unit Net Price",
                value: "formattedPriceUnitNet",
            },
            {
                key: "formattedNetAmount",
                label: (_f = (0, i18n_1.trans)("net_amount_opened_list", "Net Amount", "open_order_items")) !== null && _f !== void 0 ? _f : "Net Amount",
                value: "formattedNetAmount",
            },
        ]);
        const openOrderItemShippedListFields = (0, vue_3.ref)([
            {
                key: "productId",
                label: (_g = (0, i18n_1.trans)("item_id_shipped_list", "Item ID", "open_order_items")) !== null && _g !== void 0 ? _g : "Item ID",
                value: "productId",
            },
            {
                key: "productName",
                label: (_h = (0, i18n_1.trans)("name_shipped_list", "Name", "open_order_items")) !== null && _h !== void 0 ? _h : "Name",
                value: "productName",
            },
            {
                key: "quantity",
                label: (_j = (0, i18n_1.trans)("quantity_shipped_list", "Quantity", "open_order_items")) !== null && _j !== void 0 ? _j : "Quantity",
                value: "quantity",
            },
            {
                key: "formattedPriceUnitNet",
                label: (_k = (0, i18n_1.trans)("net_unit_price_shipped_list", "Net Unit Price", "open_order_items")) !== null && _k !== void 0 ? _k : "Unit Net Price",
                value: "formattedPriceUnitNet",
            },
            {
                key: "formattedNetAmount",
                label: (_l = (0, i18n_1.trans)("net_amount_shipped_list", "Net Amount", "open_order_items")) !== null && _l !== void 0 ? _l : "Net Amount",
                value: "formattedNetAmount",
            },
        ]);
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (__props.openOrder !== undefined && __props.openOrder.openedItems.length > 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                        (0, vue_2.createElementVNode)("h1", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("opened_items", "Opened items", "open_order_items")), 1),
                        (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                            fields: openOrderItemOpenedListFields.value,
                            "onUpdate:fields": _cache[0] || (_cache[0] = ($event) => ((openOrderItemOpenedListFields).value = $event)),
                            items: __props.openOrder.openedItems,
                            striped: "",
                            condensed: "",
                            panel: ""
                        }, {
                            "cell-quantity": (0, vue_2.withCtx)(({ item: orderItemOpened }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)(orderItemOpened
                                    .quantity), 1)
                            ]),
                            "cell-reservedQuantity": (0, vue_2.withCtx)(({ item: orderItemOpened }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_4, (0, vue_2.toDisplayString)(orderItemOpened
                                    .reservedQuantity), 1)
                            ]),
                            "cell-formattedPriceUnitNet": (0, vue_2.withCtx)(({ item: orderItemOpened }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_5, (0, vue_2.toDisplayString)(orderItemOpened
                                    .formattedPriceUnitNet), 1)
                            ]),
                            "cell-formattedNetAmount": (0, vue_2.withCtx)(({ item: orderItemOpened }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_6, (0, vue_2.toDisplayString)(orderItemOpened
                                    .formattedNetAmount), 1)
                            ]),
                            _: 1
                        }, 8, ["fields", "items"])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                (__props.openOrder !== undefined && __props.openOrder.shippedItems.length > 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, [
                        (0, vue_2.createElementVNode)("h1", _hoisted_8, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("shipped_items", "Shipped items", "open_order_items")), 1),
                        (0, vue_2.createElementVNode)("div", null, [
                            (0, vue_2.createElementVNode)("div", null, [
                                (0, vue_2.createElementVNode)("span", _hoisted_9, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("packing_slip_id", "Packing Slip ID", "open_order_items")) + ":", 1),
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(__props.openOrder.shippedItemsInfo.packingSlipId), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", null, [
                                (0, vue_2.createElementVNode)("span", _hoisted_10, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("created_at", "Created At", "open_order_items")) + ":", 1),
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(__props.openOrder.shippedItemsInfo.date), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", null, [
                                (0, vue_2.createElementVNode)("span", _hoisted_11, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delivery_name", "Delivery Name", "open_order_items")) + ":", 1),
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(__props.openOrder.shippedItemsInfo.deliveryName), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", null, [
                                (0, vue_2.createElementVNode)("span", _hoisted_12, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delivery_address", "Delivery Address", "open_order_items")) + ":", 1),
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(__props.openOrder.shippedItemsInfo.deliveryZip) + " " + (0, vue_2.toDisplayString)(__props.openOrder.shippedItemsInfo.deliveryCity) + ", " + (0, vue_2.toDisplayString)(__props.openOrder.shippedItemsInfo.deliveryStreet), 1)
                            ])
                        ]),
                        (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                            fields: openOrderItemShippedListFields.value,
                            "onUpdate:fields": _cache[1] || (_cache[1] = ($event) => ((openOrderItemShippedListFields).value = $event)),
                            items: __props.openOrder.shippedItems,
                            striped: "",
                            condensed: "",
                            panel: ""
                        }, {
                            "cell-quantity": (0, vue_2.withCtx)(({ item: orderItemShipped }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_13, (0, vue_2.toDisplayString)(orderItemShipped
                                    .quantity), 1)
                            ]),
                            "cell-formattedPriceUnitNet": (0, vue_2.withCtx)(({ item: orderItemShipped }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_14, (0, vue_2.toDisplayString)(orderItemShipped
                                    .formattedPriceUnitNet), 1)
                            ]),
                            "cell-formattedNetAmount": (0, vue_2.withCtx)(({ item: orderItemShipped }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_15, (0, vue_2.toDisplayString)(orderItemShipped
                                    .formattedNetAmount), 1)
                            ]),
                            _: 1
                        }, 8, ["fields", "items"])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 64));
        };
    }
});
